import React from 'react';

export default function NoData() {
  return <p>Sem dados disponíveis.</p>;
}